import PauseAdInfoContainer from '@components/atoms/container/pauseAdInfoContainer';
import PauseAdPlayIconContainer from '@components/atoms/container/pauseAdPlayIconContainer';
import PlayIcon from '@components/atoms/icons/play';
import PauseAdPoster from '@components/atoms/images/pauseAdPoster';
import PauseAdEventInfo from './pauseAdEventInfo';
import Event from '@shared/classes/event';

/**
 * Component that displays the main pause ad information overlay.
 * Shows event poster, play icon, and event details in a gradient overlay.
 *
 * @param {Object} props - Component props
 * @param {Event} props.event - The event to display information for
 * @returns {JSX.Element} Pause ad info container with poster, play button, and event info
 */
export default function PauseAdInfo({ asset }: { asset?: Event }) {
  return asset ? (
    <PauseAdInfoContainer>
      <PauseAdPoster src={asset?.poster}></PauseAdPoster>
      <PauseAdPlayIconContainer>
        <PlayIcon focused={true} width={48} height={55}></PlayIcon>
      </PauseAdPlayIconContainer>
      <PauseAdEventInfo asset={asset}></PauseAdEventInfo>
    </PauseAdInfoContainer>
  ) : null;
}

// TOP: 408 LEFT: 86
